import styled from 'styled-components';

import {
  Dropdown as DropdownComponent,
  FormField as FormFieldComponent,
} from '@xing-com/text-field';
import { spaceXXL } from '@xing-com/tokens';

// Removes helperText bottom margin
export const FormField = styled(FormFieldComponent)`
  &:not(:first-of-type) {
    margin-top: ${spaceXXL};
  }

  p:last-of-type {
    margin-bottom: 0;
  }
`;

export const Dropdown = styled(DropdownComponent)`
  p:last-of-type {
    margin-bottom: 0;
  }
`;
